import {
	allowedDocExtensions,
	allowedDoctyeps,
} from "../../Common/Constants/AllowedDoctypes";

function checkAllowedFileType(fileData) {
	if (!fileData || fileData.length === 0) {
		return false;
	}

	const allowedExts = allowedDocExtensions.map((ext) => ext.toLowerCase());
	const allowedMimes = allowedDoctyeps.map((type) => type.toLowerCase());

	for (let i = 0; i < fileData.length; i++) {
		const name = (fileData[i]?.name || "").toLowerCase();
		const type = (fileData[i]?.type || "").toLowerCase();
		const hasAllowedExt = allowedExts.some((ext) => name.endsWith(ext));
		if (!hasAllowedExt && !allowedMimes.includes(type)) {
			return false;
		}
	}

	return true;
}

export default checkAllowedFileType;
